import axios from 'axios';

/**
 * Sentralisert axios-instans med auth-interceptor og feilhåndtering.
 * 
 * Bruk: import api from '@/lib/api';
 *       api.get('/suppliers-config/list')   // /api-prefiks legges til automatisk
 */
const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  timeout: 120000,
  headers: { 'Content-Type': 'application/json' },
  // Lister må sendes som ?a=1&a=2 (ikke a[]=1&a[]=2) — FastAPI leser bare den
  // første formen, ellers blir f.eks. «kun markerte rader» stille ignorert.
  paramsSerializer: {
    indexes: null,
  },
});

// ── Request interceptor: legg til auth-token automatisk ──
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Hvis body er FormData (opplasting), fjern default application/json
    // slik at axios kan sette riktig multipart/form-data header med boundary.
    if (config.data instanceof FormData) {
      if (config.headers && config.headers['Content-Type']) {
        delete config.headers['Content-Type'];
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ── Response interceptor: håndter 401 og nettverksfeil ──
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token utløpt eller ugyldig — logg ut
      localStorage.removeItem('auth_token');
      localStorage.removeItem('user');

      // Redirect til login (unngå loop hvis allerede på /login)
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
